<template>
    <div class="d-flex justify-content-end mt-5 mb-2 picker">
        <!-- <div class="p-3 radius-normal fs-small bg-darkest dark flex-all d-flex">
            <i class="ico-search largest mr-3"></i>
            <input class="flex-all bg-transparent border-0 p-0 m-0 medium" type="text" @keyup="typing" placeholder="What are you looking for?">
        </div> -->

        <div class="d-flex pointer bg-darkest align-items-center px-4 radius-normal medium normal" @click="toggleAvailability">
            <div class="mr-3">
                <i class="ico-calendar larger"></i>
                <span v-if="dateFrom || dateTo">{{ dateFrom }} to {{ dateTo }}</span>
                <span v-else>(Pick a date ...)</span>
            </div>
<!--
            <div>
                <i class="ico-people larger"></i>
                <span v-if="paxTotal">{{ paxTotal }} pax</span>
                <span v-else>(Add people ...)</span>
            </div> -->
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        props: {
            paxTotal: Number,
            newReservationSetup: Object,
        },
        computed: {
            ...mapGetters([
                'getEvents',
            ]),
            dateFrom: function() {
                return this.newReservationSetup.from ? this.formatDate(this.newReservationSetup.from) : null;
            },
            dateTo: function() {
                return this.newReservationSetup.to ? this.formatDate(this.newReservationSetup.to) : null;
            }
        },
        methods: {
            ...mapActions([
                'updateNewReservationSetup',
                'emptyNewReservationSetupList',
            ]),
            toggleAvailability: function() {
                this.$emit('toggleAvailability');
            },
            typing: function(e) {
                var val = e.target.value;

                if (val.length > 1) {
                    // Intersect the search results for this query with the current list (holding other filters)

                    let events = [];

                    this.getEvents.forEach(event => {
                        let found = event.products.filter(i => i.name.toLowerCase().indexOf(val.toLowerCase()) !== -1);

                        if (found && found.length > 0) {

                            events.push(event);
                        }
                    });

                    if (events.length > 0) {
                        this.updateNewReservationSetup({ query: events });
                    }
                    else {
                        this.emptyNewReservationSetupList();
                    }
                }
                else {
                    this.updateNewReservationSetup({ query: null });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .picker {
        height: 36px;
    }
</style>



// WEBPACK FOOTER //
// AddFilters.vue?17903082